export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.Inspections'

export const INSPECTIONS_TABLE_CHANGE = 'INSPECTIONS_TABLE_CHANGE'
export const INSPECTIONS_TABLE_DATA_RECEIVED = 'INSPECTIONS_TABLE_DATA_RECEIVED'
export const INSPECTIONS_TABLE_LOADING_TRUE = 'INSPECTIONS_TABLE_LOADING_TRUE'
export const INSPECTIONS_TABLE_LOADING_FALSE = 'INSPECTIONS_TABLE_LOADING_FALSE'

export const INSPECTIONS_TABLE_CHANGE_REQUEST = (id) => `INSPECTIONS_${id}_TABLE_CHANGE_REQUEST`
